<template>
  <footer class="footer-container">
    <div class="content has-text-centered">
      <div v-if="true" class="columns is-centered is-vcentered">
        <div class="column is-2">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/golstats_shield_black.svg" alt="GolStats Shield" />
        </div>
        <!--        <div class="column is-2 text-golstats">-->
        <!--          Protocolo GolStats-->
        <!--        </div>-->
        <!--        <div class="column is-2 text-golstats">-->
        <!--          Ayuda-->
        <!--        </div>-->
      </div>
      <hr />
      <div class="text-area columns is-vcentered">
        <div class="column text-copyright" :class="columnsNumber">&copy; {{ $t('general.rights_reserved') }}</div>
        <div v-if="isNationalTournament" class="column is-2">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/citec-logo-footer.png" alt="Citec logo footer" />
        </div>
        <div v-if="isNationalTournament" class="column is-2">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/logo-liga-mx-footer.png" alt="Ligamx logo footer" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    showComplete: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('loginGeneral', ['isNationalTournament']),
    columnsNumber() {
      return this.isNationalTournament ? ['is-8'] : ['is-12'];
    },
  },
};
</script>

<style scoped>
hr {
  border-top: 2px solid #7ed321;
}
.footer-container {
  background-color: transparent;
  margin-top: 20px;
}
.text-area {
  padding: 0 52px 18px;
}
.text-copyright {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: justify;
  color: #72707c;
}
.text-golstats {
  font-family: Roboto;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #808285;
}
</style>
